define(function(require, exports, module) {
    'use strict';
    var i18n = require('i18n');

    module.exports = function(isDetailed) {
        return {
            transactionPeriodStart: {
                fn: {
                    fn: function($inputs, config, form) {
                        if (form.data('period') !== 'another_period') {
                            return true;
                        }

                        var transactionYear = Number(form.data('year_startDate'));
                        var transactionMonth = Number(form.data('month_startDate'));
                        var transactionDay = Number(form.data('day_startDate'));
                        var areAllInputsFilled = Boolean(transactionDay && transactionMonth && transactionYear);

                        if (!areAllInputsFilled) {
                            this.message = i18n.t('playtech.mobile.system.user.tooltip.birthdate.required');
                            return false;
                        }

                        return true;
                    }
                }
            },

            transactionPeriodEnd: {
                fn: {
                    fn: function($inputs, config, form) {
                        if (form.data('period') !== 'another_period') {
                            return true;
                        }

                        var transactionYear = Number(form.data('year_endDate'));
                        var transactionMonth = Number(form.data('month_endDate'));
                        var transactionDay = Number(form.data('day_endDate'));
                        var areAllInputsFilled = Boolean(transactionDay && transactionMonth && transactionYear);
                        var endDate;
                        var startDate;
                        var maxEndDate;

                        if (areAllInputsFilled) {
                            endDate = new Date(transactionYear, transactionMonth - 1, transactionDay, 23, 59, 59);
                            startDate = new Date(
                                form.data('year_startDate'),
                                form.data('month_startDate') - 1,
                                form.data('day_startDate')
                            );

                            if (startDate > endDate) {
                                this.message = i18n.t('playtech.mobile.system.mobile-cashier.transactions.wrongRange');

                                return false;
                            }

                            maxEndDate = new Date(startDate);

                            if (isDetailed) {
                                maxEndDate.setDate(maxEndDate.getDate() + 7);
                            } else {
                                maxEndDate.setMonth(maxEndDate.getMonth() + 3);
                            }

                            if (endDate > maxEndDate) {
                                this.message = i18n.t('playtech.mobile.system.mobile-cashier.transactions.'
                                    + (isDetailed ? 'weekDifference' : 'monthDifference'));

                                return false;
                            }
                        } else {
                            this.message = i18n.t('playtech.mobile.system.user.tooltip.birthdate.required');

                            return false;
                        }

                        return true;
                    }
                }
            }
        };
    };
});
